import React, { useState, useContext } from 'react';
import { motion } from 'framer-motion';
import { UserContext } from '../../../context/UserContext';
import { SystemError } from '../../error/SystemError';
import { dismissModal } from '../../../service/modal-service';
import { removePost } from '../../../api/post/buzz-api';
import { LoadingCover } from '../../commons/LoadingCover';
import BottomSheet from '../../commons/BottomSheet';
import { Trash2, AlertTriangle } from 'lucide-react';

export const BuzzDelete = (props) => {
    const refreshBuzz = props.refreshBuzz
    const editEntityId = props.editEntityId

    const [isOpen, setIsOpen] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [isSystemError, setIsSystemError] = useState(false)
    const [errorContent, setErrorContent] = useState({'header': "", 'body': ""})
    
    const { userId } = useContext(UserContext)

    const handleClose = () => {
        dismissModal()
    }

    const deleteBuzz = async() => {
        setIsLoading(true)
        try {
            await removePost(editEntityId, userId)
            setIsLoading(false)
            refreshBuzz()
            dismissModal()
        } catch (error) {
            console.log(error)
            setErrorContent({ 'header': "Error deleting post", 'body': "Please try again. If problem persists, contact us at support@stringssg.com" })
            setIsSystemError(true)
            setIsLoading(false)
        }
    }

    return (
        <>
            <BottomSheet isOpen={isOpen} onClose={handleClose} maxWidth="md">
                <BottomSheet.Header>
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                            <Trash2 className="w-5 h-5 text-red-600" />
                        </div>
                        <BottomSheet.Title>Delete Post</BottomSheet.Title>
                    </div>
                </BottomSheet.Header>

                <BottomSheet.Content>
                    <div className="flex items-start gap-3 p-4 bg-amber-50 rounded-xl border border-amber-100">
                        <AlertTriangle className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" />
                        <p className="text-sm text-gray-600">
                            Deleting this post will also remove all likes and comments. This action cannot be undone.
                        </p>
                    </div>
                </BottomSheet.Content>

                <BottomSheet.Footer>
                    <div className="flex gap-3">
                        <BottomSheet.CloseButton>Cancel</BottomSheet.CloseButton>
                        <motion.button 
                            whileTap={{ scale: 0.98 }}
                            type="button" 
                            className="flex-1 px-4 py-3 rounded-xl font-semibold text-white bg-linear-to-r from-red-600 to-red-500 shadow-lg shadow-red-200 disabled:opacity-50" 
                            disabled={isLoading}
                            onClick={deleteBuzz}
                        >
                            {isLoading ? 'Deleting...' : 'Delete Post'}
                        </motion.button>
                    </div>
                </BottomSheet.Footer>
            </BottomSheet>

            {isLoading && <LoadingCover />}
            {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError} />}
        </>
    )
}
